{
  "id": "campaign-104",
  "name": "Weedy Gardens",
  "seed": "campaign:104",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,ACCA,,,,,",
    ",,,,,,CC...x,,",
    ",,,t,,CC..t,,,",
    ",,****CC****,,",
    "x,,,,~CC,,,,,,",
    ",,,,~~CC,,,,,,",
    ",,,t,,CC,,t,,,",
    ",,,,hCCCCh,,,,",
    "CCCCCCOOCCCCCC",
    "x,,,,CCCC,,,,,",
    ",,,t,,CC,,t,,,",
    ",h..h,CC,h..h,",
    ",.t..tCCt..t..",
    "......,,,,....",
    "S.....,,,,...."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 10,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 3
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "rare",
      "x": 2,
      "y": 8
    }
  ],
  "generatorVersion": 3,
  "level": 104,
  "biome": "estate",
  "par": {
    "reel": 6219,
    "push": 5344,
    "selfPropelled": 4974,
    "tractor": 4086,
    "zeroTurn": 3418,
    "fairway": 2113
  },
  "goldTime": {
    "reel": 6129,
    "push": 5162,
    "selfPropelled": 4908,
    "tractor": 4013,
    "zeroTurn": 3418,
    "fairway": 2113
  },
  "routeTries": {
    "par": {
      "reel": 11,
      "push": 17,
      "selfPropelled": 1,
      "tractor": 21,
      "zeroTurn": 14,
      "fairway": 9
    },
    "gold": {
      "reel": 48,
      "push": 45,
      "selfPropelled": 30,
      "tractor": 42,
      "zeroTurn": 14,
      "fairway": 9
    }
  }
}
